import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'atrius-app-bar-right-area',
  template: `
    <div>
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./right-area.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RightAreaComponent {}
